module.exports = __webpack_public_path__ + "static/media/IeDisabled.27f36cb9.svg";